import Repository from '@/repositories/RepositoryFactory';
import ENUM from '../../enums/APISTATE';
import store from '../';
import UPDATESTATE from '../../enums/UPDATESTATE';

const notificationsRepository = Repository.get('notifications');

export default ({
  namespaced: true,
  state: {
    apiState: ENUM.INIT,
    notifications: [],
    notification: {},
    errorModalOpen: false,
    errorModalText: ''
  },
  mutations: {
    setApiState: (state, apiState) => {
      state.apiState = apiState;
    },
    setNotification(state, response) {
      const { data } = response;
      state.notification = data;
      state.apiState = ENUM.LOADED;
    },
    setNotifications(state, response) {
      const { data } = response;
      state.notifications = data;
      state.apiState = ENUM.LOADED;
    },
    initialized(state, { notifications }) {
      state.notifications = notifications;
    },
    setErrorModalText(state, text){
      state.errorModalText = text
    },
    setErrorModalOpen(state, open){
      state.setErrorModalOpen = open;
    }
  },
  actions: {
    async getNotificationsForPeriod({ commit }, request) {
      commit('setApiState', ENUM.LOADING);
      try {
        commit('setNotifications', await notificationsRepository.getForPeriod(request.startDate, request.endDate, request.forRegion));
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async createNotification({ commit, dispatch }, allocationDto) {
      commit('setApiState', ENUM.LOADING);
      let retries = 0;
      while(retries < 2){
        if(allocationDto.updateState !== UPDATESTATE.RequestReplacement){
          retries = 2;
        }
        try {
          retries++;
          let result = await notificationsRepository.create(allocationDto);
          if (result.status === 200) {
            commit("setApiState", ENUM.LOADED);
            commit("setAllocation", result);
            return true;
          }
        } catch (error) {
          if(allocationDto.updateState !== UPDATESTATE.RequestReplacement){
            commit("setApiState", ENUM.ERROR);
            return false
          }
          if (retries < 2) {
            // do nothing
          }
          else{
            console.error(error);
            commit('setApiState', ENUM.ERROR);
            return false;
          }
        }
      }
    },
    async deleteNotification({ commit, dispatch }, notificationDto) {
      commit('setApiState', ENUM.LOADING);
      try {
        await notificationsRepository.delete(notificationDto.id, notificationDto._UpdateTag);
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async updateNotification({ commit, dispatch }, notificationDto) {
      commit('setApiState', ENUM.LOADING);
      try {
        await notificationsRepository.update(notificationDto);
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async getNotificationFromAllocation({ commit, dispatch }, allocationDto) {
      if(!allocationDto || !allocationDto.id) {
        return;
      }

      commit('setApiState', ENUM.LOADING);
      try {        
        commit('setNotification', await notificationsRepository.getNotificationFromAllocation(allocationDto.id));
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    setNotificationOnStore(state, data) {
      state.notification = data;
      state.apiState = ENUM.LOADED;
    },
  },
  getters: {
    notificationApiState(state) {
      return state.apiState;
    },
    notification(state) {
      return state.notification;
    },
    notifications(state) { 
      return state.notifications; 
    },
    errorModalOpen: (state) => {return state.errorModalOpen},
    errorModalText: (state) => {return state.errorModalText}
  }
});
